var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"23","height":"23","rx":"5.5","stroke":"#ECEFF9"}})])}
var staticRenderFns = []

export { render, staticRenderFns }